export const landing = {
  /** Split so the savings figure can be picked out in the brand lime. */
  headline: {
    before: "Save ",
    highlight: "75%",
    after: " on your pregnancy bill",
  },
  banner: "Guaranteed results or it's free",
  stats: {
    upfront: { value: "$0", label: "Upfront cost" },
    rating: { value: "4.9", label: "Average rating" },
  },
  trust: "HIPAA secure · 5 minutes",
} as const;
